import { MUI_INPUT_BASE_CLASSNAME } from "../InputControl/Input/InputBase.js";
const styles = {
  searchStyleAdjustments: {
    svg: {
      color: (t) => t.palette.content.additional.default
    },
    ".MuiInputBase-root.MuiInputBase-root": {
      gap: 8,
      position: "relative",
      paddingLeft: 0,
      paddingInlineStart: 0,
      ".start-adornment-container": {
        width: "auto",
        position: "absolute",
        left: 12
      },
      [`.${MUI_INPUT_BASE_CLASSNAME}`]: {
        paddingLeft: 40
      }
    }
  }
};
export {
  styles
};
//# sourceMappingURL=styles.js.map
